import { useState, useEffect } from 'react';

export const useTiptap = () => {
  const [tiptap, setTiptap] = useState(null);

  useEffect(() => {
    const loadTiptap = async () => {
      const [tiptapReact, starterKit, taskItem, taskList, tiptapPm] =
        await Promise.all([
          import('@tiptap/react'),
          import('@tiptap/starter-kit'),
          import('@tiptap/extension-task-item'),
          import('@tiptap/extension-task-list'),
        ]);

      setTiptap({
        ...tiptapReact,
        StarterKit: starterKit.default,
        TaskItem: taskItem.default,
        TaskList: taskList.default,
      });
    };

    loadTiptap();
  }, []);

  return tiptap;
};
